'use client';

import { InventoryTurnoverValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: InventoryTurnoverValues;
  onValuesChange: (field: keyof InventoryTurnoverValues, value: number) => void;
  translations: ToolsTranslations['inventoryTurnover'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof InventoryTurnoverValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.costOfGoodsSold}</label>
        <input type="text" value={values.costOfGoodsSold.toLocaleString('sv-SE')} onChange={handleChange('costOfGoodsSold')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.beginningInventory}</label>
        <input type="text" value={values.beginningInventory.toLocaleString('sv-SE')} onChange={handleChange('beginningInventory')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.endingInventory}</label>
        <input type="text" value={values.endingInventory.toLocaleString('sv-SE')} onChange={handleChange('endingInventory')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


